import { FormGroup } from '@angular/forms';
import * as moment from 'moment';

// custom validator to check that two fields match
export function MustBeAfter(firstControlName: string, secondControlName: string) {
    return (formGroup: FormGroup) => {
        const firstControl = formGroup.controls[firstControlName];
        const secondControl = formGroup.controls[secondControlName];

        // set error on secondControl if validation fails (second date il before first date)
        if (firstControl && secondControl && firstControl.value && secondControl.value){
            if (firstControl.value.singleDate && secondControl.value.singleDate) {
                let firstDate = firstControl.value.singleDate.jsDate;
                let secondDate = secondControl.value.singleDate.jsDate;
                if (moment(secondDate).isBefore(firstDate)) {
                    secondControl.setErrors({ mustBeAfter: true });
                } else {
                    secondControl.setErrors(null);
                }
            }
        } 
    }
}